import { css } from '@emotion/react';

export const styles = {
  ToggleButton: css`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border: none;
    background: none;
    padding: 0;
    margin: 0;
  `,
};
